import Box from '@mui/material/Box';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux'
import { useCommonStyles } from '../../common/common';
import { onGetAllCategories, onGetAllSubCategories } from '../../store/actions/Category';
import Products from './Main/ProductLists';
import TopSellers from './Main/TopSeller';

const Layout = (props: any) => {
	const dispatch = useDispatch()
	const {category, subcategory} = props.match.params
	const commonClasses = useCommonStyles()
	useEffect(() => {
		dispatch(onGetAllCategories())
		dispatch(onGetAllSubCategories())
	}, [dispatch])

	return (
		<Box className={commonClasses.mainContainer}>
			<TopSellers />
			<Products selectedCategory={category} selectedSubCategory={subcategory} />
		</Box>
	);
}

export default Layout;
